import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {Driver, IDriver} from 'app/blocks/model/driver.model';

export interface IVehicleInspectionReport extends IBaseEntity {
    id?: number;
    inspectionDate: string;
    vehicleName?: string;
    driver: IDriver;
    vehicleReportStatus?: string;
    trailerReportStatus?: string;
    pdfAvailable?: boolean;
    inspectionTime?: string;
    vehicleId?: number;
    trailerId?: number;
    trailerName?: string;
    isPDFAvailable?: boolean;
}

export class VehicleInspectionReport extends BaseEntity implements IVehicleInspectionReport {
    public id?: number;
    public inspectionDate: string;
    public vehicleName?: string;
    public driver: Driver;
    public vehicleReportStatus?: string;
    public trailerReportStatus?: string;
    public pdfAvailable?: boolean;
    public inspectionTime?: string;
    public vehicleId?: number;
    public trailerId?: number;
    public trailerName?: string;

    constructor(vehicleInspectionReport?: any) {
        super();
        if (vehicleInspectionReport) {
            this.id = vehicleInspectionReport.id;
            this.driver = vehicleInspectionReport.driver;
            this.inspectionDate = vehicleInspectionReport.inspectionDate;
            this.vehicleName = vehicleInspectionReport.vehicleName;
            this.vehicleReportStatus = vehicleInspectionReport.vehicleReportStatus;
            this.trailerReportStatus = vehicleInspectionReport.trailerReportStatus;
            this.pdfAvailable = vehicleInspectionReport.pdfAvailable;
            this.inspectionTime = vehicleInspectionReport.inspectionTime;
            this.vehicleId = vehicleInspectionReport.vehicleId;
            this.trailerId = vehicleInspectionReport.trailerId;
            this.trailerName = vehicleInspectionReport.trailerName;
        }
    }
    get discriminator(): any {
        return this.id;
    }

    clone(): IVehicleInspectionReport {
        return new VehicleInspectionReport(this);
    }
}
